import { useTranslation } from 'react-i18next';
import type { ApprovalTab } from '@/hooks/useApprovals';

interface TabDef {
  key: ApprovalTab;
  labelKey: string;
}

const TABS: readonly TabDef[] = [
  { key: 'pending', labelKey: 'approvals.tab_pending' },
  { key: 'mine', labelKey: 'approvals.tab_mine' },
  { key: 'history', labelKey: 'approvals.tab_history' },
];

interface ApprovalTabsProps {
  current: ApprovalTab;
  onChange: (tab: ApprovalTab) => void;
  pendingCount: number;
}

export function ApprovalTabs({ current, onChange, pendingCount }: ApprovalTabsProps) {
  const { t } = useTranslation();
  return (
    <div className="appr-tabs" role="tablist">
      {TABS.map((tab) => (
        <button
          key={tab.key}
          type="button"
          role="tab"
          aria-selected={current === tab.key}
          className={current === tab.key ? 'appr-tab active' : 'appr-tab'}
          onClick={() => onChange(tab.key)}
        >
          {t(tab.labelKey)}
          {tab.key === 'pending' && pendingCount > 0 && (
            <span className="appr-tab-count">{pendingCount}</span>
          )}
        </button>
      ))}
    </div>
  );
}
